export const NOT_READY_COLOR = 'lightgrey';
export const PLAYER_COLORS = ['red', 'blue', 'green', 'yellow'];
